import { render, staticRenderFns } from "./notification-list.vue?vue&type=template&id=5789a83d&scoped=true"
import script from "./notification-list.vue?vue&type=script&lang=js"
export * from "./notification-list.vue?vue&type=script&lang=js"
import style0 from "./notification-list.vue?vue&type=style&index=0&id=5789a83d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5789a83d",
  null
  
)

export default component.exports